"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isParticipatedYearsProperty = exports.participatedYearsPropertyDefinition = void 0;
exports.participatedYearsPropertyDefinition = {
    view: {
        label: 'Participated in',
        hint: 'Year(s) in which the photographer has submitted a participation for RB Illume',
    },
    constraints: [
        {
            name: 'min',
            argument: 1700,
        },
        {
            name: 'max',
            argument: 2100,
        },
    ],
    type: 'int',
    multiple: true,
    name: 'participated-years',
};
const isParticipatedYearsProperty = (prop) => {
    return prop.name === exports.participatedYearsPropertyDefinition.name;
};
exports.isParticipatedYearsProperty = isParticipatedYearsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydGljaXBhdGVkLXllYXJzLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcGFydGljaXBhdGVkLXllYXJzLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsbUNBQW1DLEdBQUc7SUFDakQsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGlCQUFpQjtRQUN4QixJQUFJLEVBQUUsK0VBQStFO0tBQ3RGO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsS0FBSztZQUNYLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxLQUFLO1lBQ1gsUUFBUSxFQUFFLElBQUk7U0FDZjtLQUNGO0lBQ0QsSUFBSSxFQUFFLEtBQUs7SUFDWCxRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxvQkFBb0I7Q0FDSyxDQUFBO0FBSTFCLE1BQU0sMkJBQTJCLEdBQUcsQ0FBQyxJQUFrQixFQUFxQyxFQUFFO0lBQ25HLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywyQ0FBbUMsQ0FBQyxJQUFJLENBQUE7QUFDL0QsQ0FBQyxDQUFBO0FBRlksUUFBQSwyQkFBMkIsK0JBRXZDIn0=